<template>
    <section
        class="bg-white dark:bg-slate-800 mb-8 shadow dark:shadow-slate-900/50 ring-1 ring-black/5 rounded-lg col-span-12 lg:col-span-6 md:min-h-[400px]"
    >
        <div class="px-6 py-6">
            <div class="truncate">
                <div class="flex justify-between">
                    <div
                        class="text-lg font-medium text-slate-800 dark:text-slate-100 justify-between flex gap-2"
                    >
                        <icon icon="pass" />
                        Companion Pass
                    </div>
                </div>
            </div>
            <div class="mt-12">
                <div class="relative isolate">
                    <div
                        class="mx-auto max-w-7xl lg:flex lg:items-center lg:gap-x-10"
                    >
                        <div class="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
                            <h1
                                class="text-4xl font-semibold tracking-tight text-slate-800 dark:text-slate-100 sm:text-4xl"
                            >
                                <span class="text-orange">
                                    Congratulations!
                                </span>
                                <br />
                                <span>You’ve done your part</span>
                            </h1>
                            <p class="mt-2 text-sm text-slate-500 dark:text-slate-400 font-normal">
                                You’ve met the criteria to earn Southwest
                                companion pass - now you
                                <br />
                                just have to wait for your Companion pass to
                                post to your
                                <br />
                                Southwest rapid rewards account.
                            </p>
                            <div class="mt-8">
                                <div
                                    class="inline-flex items-center mr-5 gap-2"
                                >
                                    <button
                                        type="button"
                                        class="flex items-center justify-center gap-2 px-4 py-2.5 font-medium text-sm rounded-md bg-orange shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 text-white"
                                    >
                                        View More
                                    </button>
                                    <button
                                        type="button"
                                        class="flex p-2.5 items-start gap-2 px-4 py-2.5 font-medium text-sm rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/50 text-slate-800 dark:text-slate-100"
                                    >
                                        Dismiss
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-2 flex justify-end relative">
                            <div
                                class="absolute bottom-[-8rem] left-[-8rem] w-[500px]"
                            >
                                <img
                                    src="/images/companionpass/illustrationSouthWest.png"
                                    alt="Southwest Companion Pass"
                                    class="w-full"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
//import Congratulations from '../Companion-pass-congratulations.vue';
import Icon from '../../ui/icon/icon.vue';
</script>
